import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueries";

export const aiAssistAPI = createApi({
    reducerPath: "aiAssistAPI",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["AiAssist"],
    endpoints: (builder) => ({
        uploadDocument: builder.mutation({
            query: ({ formData }) => {
                return {
                    url: `/api/supply_chain_document_ai/`,
                    method: "POST",
                    body: formData,
                };
            },
            invalidatesTags: ["AiAssist"],
        }),
        processDocument: builder.mutation({
            query: ({ asset_type_id, documents_to_process, batch }) => {
                return {
                    url: `/api/supply_chain_document_ai/process-documents/`,
                    method: "POST",
                    body: { asset_type_id, documents_to_process, batch },
                };
            },
        }),
    }),
});

export const { useUploadDocumentMutation, useProcessDocumentMutation } =
    aiAssistAPI;
